var cbtUtil = require("./cbtUtil");
var debounce = require("lodash/debounce");
var setCookie = require("coremh/components/cookieSetup").setCookie;
var getCookie = require("coremh/components/cookieSetup").getCookie;
var deleteCookie = require("coremh/components/cookieSetup").deleteCookie;
var $cache = {};
var cbtProductCarousel = require("./components/cbtProductCarousel");

/**
 * Initiates cache
 */
function initCache() {
    $cache.document = $(document);
}

function footerLinksEvent() {
    $(".menu-footer.content > li > a").on("click", function () {
        var redirectionLinkName = $(this).data("en") || $(this).text() || "";
        var dataLayer = {
            "event": "navigationLinkClick",
            "redirectionLinkName": redirectionLinkName,
            "siteLocation": "Footer"
        };

        cbtUtil.dataPush(dataLayer);
    });
}

function cbtSocialNetworks() {
    $cache.document.on("click", ".social-links > li > a.icon-link", function () {
        const $this = $(this);
        var socialNetwork = $this.data("social-network");
        var dataLayer = {
            "event": "socialShare",
            "socialAction": "Like",
            "socialNetwork": socialNetwork
        };
        cbtUtil.dataPush(dataLayer);
    });
}

function setSuggestionsCookie() {
    let cookieEnabled =  $("#cbt-site-location").data("cookie-enabled");

    if (cookieEnabled) {
        $("body").on("click", ".suggestions", function () {
            let action = "SearchServices-GetSuggestions";
            let clickData = $(".suggestions [data-cbt]").data("cbt");
            let querystring = clickData.label;
            let cookieValue = [
                action,
                querystring,
                "", // position
                "", // listName
                "", // listType
            ].join("|");

            setCookie("eeListClick_pdp_doPush", "1");
            setCookie("previousSiteLocation", cookieValue);
        });
    }
}

/**
 * @param {Object} $target jQuery object
 * @param {boolean} justPush If true, does the push without modifying datalayer
 */
function cbtAddToCartAjax($target, justPush) {
    const $page = $(".page[data-action][data-querystring]");

    $.ajax({
        url: $("#cbt-site-location").data("product-click-url"),
        method: "GET",
        dataType: "json",
        data: {
            productID: $target.attr("data-pid"),
            action: $page.attr("data-action"),
            querystring: $page.attr("data-querystring")
        },
        success: function (data) {
            var dataLayer = cbtUtil.parseJSON(data.cbtProductClick);
            if (!dataLayer) {
                return;
            }
            if (!justPush) {
                if (dataLayer["listName"] == "") {
                    var listName = $target
                        .parents(".tab-carousel-wrapper")
                        .find(".section-title")
                        .text()
                        .replace("\n", "")
                        .trim();
                    if (listName) {
                        dataLayer.listName = listName;
                    }
                }
                if (dataLayer.products && dataLayer.products[0] && !dataLayer.products[0].position) {
                    var index = $target.parents(".slick-slide").data("slick-index");
                    var indexFinal = index ? index + 1 : $target.parents(".product-tile-order").data("value");
                    if (indexFinal) {
                        dataLayer.products[0].position = parseInt(indexFinal, 10);
                    }
                }
            }
            cbtUtil.dataPush(dataLayer);
        },
    });
}

function cbtCLPAddToCartData() {
    $cache.document.on("click", ".producttile-add-to-cart", function (event) {
        let $target = $(event.target);
        if (!$target.hasClass("producttile-add-to-cart")) {
            $target = $target.closest(".producttile-add-to-cart");
        }
        cbtAddToCartAjax($target, false);
    });
}

function cbtProductTileClick() {
    $cache.document.on("click", ".product-tile", function(event) {
        let $target = $(event.target);
        let index = $target.parents(".slick-slide").data("slick-index") || 0;

        // if the slick carousel is infinite, the indexes can be negative or bigger than the number of products
        // we should check if product-tile-order exists
        let productTileOrder = $target.parents(".product-tile-order").data("value");
        let indexFinal = productTileOrder ? productTileOrder : index + 1;
        let $carouselWrapper = $target.closest(".tab-carousel-wrapper");
        let carouselTitle = $carouselWrapper.find(".section-title").data("en");
        let tabTitle = $carouselWrapper.find(".cbt-brands.active").data("en");
        let listName = tabTitle ? carouselTitle + " - " + tabTitle : carouselTitle;
        let listType = "";
        const previousSiteLocation = getCookie("previousSiteLocation");
        if (previousSiteLocation) {
            const args = decodeURIComponent(previousSiteLocation).split("|");
            const pipeline = args[0] || "";
            const querystring = args[1] || "";
            const $productTileCTA = $(this).find(".producttile-add-to-cart");
            var productCbtData = $productTileCTA.length && $productTileCTA.data("cbt") ? cbtUtil.parseJSON($productTileCTA.data("cbt")) : null;

            if (productCbtData && Object.keys(productCbtData).length) {
                listName = productCbtData.listName || listName;
                listType = productCbtData.listType || listType;
            }

            setCookie("previousSiteLocation", [
                pipeline,
                querystring,
                indexFinal,
                listName,
                listType
            ].join("|"));
        }

        setCookie("eeListClick_pdp_doPush", "1");
    });
}

function cbtProductListViewGrowth() {
    var $productCarousel = $(".carousel-product");
    var $productRecomendations = $(".js-product-recommendations");
    var $productGrowthListSection = $(".product-growth-list-section");
    var $isHomePage = $("#homepage");

    if ($productGrowthListSection.length) {
        $(window).on("scroll", function() {
            $productGrowthListSection.not(".cbt-listed").each(function(i, el) {
                var $element = $(el);
                var debounceScroll;
                if ($element.hasClass("js-product-recommendations")) {
                    debounceScroll = debounce(getPDPRecomendation, 200);
                    debounceScroll(el, false);
                } else if ($element.hasClass("suggested-product")) {
                    debounceScroll = debounce(getPDPRelatedAccessories, 200);
                    debounceScroll(el);
                } else if ($isHomePage.length) {
                    debounceScroll = debounce(getHomePageProductListGrowth, 200);
                    debounceScroll(el);
                } else {
                    debounceScroll = debounce(getPDPRecomendation, 200);
                    debounceScroll(el, true);
                }
            });
        });
    }

    $productCarousel.on("afterChange", function() {
        if ($isHomePage.length) {
            var $carouselWrapper = $(this).parents(".tab-carousel-wrapper");
            var $tab = $carouselWrapper.find(".cbt-brands.active");
            var carouselTitle = $carouselWrapper.find(".section-title").data("en");
            var tabTitle = $tab.data("en");
            var listName = tabTitle ? carouselTitle + " - " + tabTitle : carouselTitle;
            const dataLayer = cbtProductCarousel.getHomePageProductListDataLayer(this, listName);
            if (dataLayer.products.length) {
                cbtUtil.dataPush(dataLayer);
            }
        }
    });

    $productRecomendations.on("afterChange", function() {
        getRecommendationsDataLayer(this);
    });
}

function getHomePageProductListGrowth(el) {
    var $element = $(el);
    var isInViewport = $element.isInViewport();
    var $carouselWrapper = $element.parents(".tab-carousel-wrapper");
    var carouselTitle = $carouselWrapper.find(".section-title").data("en");
    var $tab = $carouselWrapper.find(".cbt-brands.active");
    var tabTitle = $tab.data("en");
    var listName = tabTitle ? carouselTitle + " - " + tabTitle : carouselTitle;
    var $tabPane = $element.parents(".tab-pane");

    if (isInViewport && $tabPane.hasClass("active") && !$element.hasClass("cbt-listed")) {
        $element.addClass("cbt-listed");
        const dataLayer = cbtProductCarousel.getHomePageProductListDataLayer(el, listName);
        if (dataLayer.products.length) {
            cbtUtil.dataPush(dataLayer);
        }
    }
}

function ctbFormValidationError() {
    $cache.document.on("click", ".form-cbt-push-errors button[type='submit'], .form-cbt-push-errors input[type='submit']", function () {
        const $submitButton = $(this);
        setTimeout(() => {
            let $form = $submitButton.closest("form");
            let dataLayer = {
                event: "formError",
                formType: $("#checkout-login").length > 0 ? "Checkout" : $form.data("cbt-form-type") || "",
                formName: $form.data("cbt-form-name") || "",
                fieldName: {} // map to avoid duplicates
            };
            // using both is-invalid and required in case of inconsistent frontend validation
            let selector = [
                ".form-group.is-invalid input:not([type='hidden'])",
                ".form-group.is-invalid select",
                ".form-group.is-invalid textarea",
                "input.is-invalid:not([type='hidden'])",
                "select.is-invalid",
                "textarea.is-invalid",
                "input[required]:not([type='hidden'])",
                "select[required]",
                "textarea[required]",
            ].join(",");

            $form.find(selector).each(function () {
                if ($(this).is(":invalid")) {
                    let field = $(this).attr("name") || $(this).attr("id") || null;
                    if (field) {
                        dataLayer.fieldName[field.replace("dwfrm_", "")] = true;
                    }
                }
            });

            dataLayer.fieldName = Object.keys(dataLayer.fieldName).join("|");
            if (dataLayer.fieldName.length > 0) {
                cbtUtil.dataPush(dataLayer);
            }
        }, 300); // timeout needed because of form clear errors
    });
}

function getPDPRelatedAccessories(el) {
    var $element = $(el);
    var isInViewport = $element.isInViewport();
    var dataLayer = cbtUtil.parseJSON($element.data("cbt-suggestion"));
    if (isInViewport && !$element.hasClass("cbt-listed")) {
        var pdpDataLayer = $(".cbt-pdp");
        var dataLayerObject = cbtUtil.parseJSON(pdpDataLayer.data("pdp-cbt"));
        var productName = dataLayerObject && dataLayerObject.products.length ? dataLayerObject.products[0].name : "";

        dataLayer.listName = productName;

        $element.addClass("cbt-listed");
        cbtUtil.dataPush(dataLayer);
    }
}

function getPDPRecomendation(el) {
    var $element = $(el);
    var isInViewport = $element.isInViewport();
    if (isInViewport && !$element.hasClass("cbt-listed")) {
        $element.addClass("cbt-listed");
        getRecommendationsDataLayer(el);
    }
}

function getRecommendationsDataLayer(el) {
    var $activeSlides = $(el).find(".slick-active");
    var cbtAllPages = cbtUtil.parseJSON($(".cbt-all-pages").data("cbt-all-pages"));
    var dataLayer = {
        "event": "eeListView",
        "currencyCode": cbtAllPages && cbtAllPages.currencyCode ? cbtAllPages.currencyCode : "",
        "listName": "Something unexpected",
        "listType": "PDP - Something unexpected",
        "products": []
    };
    $activeSlides.each(function(i, el) {
        var $element = $(el);
        if (!$element.hasClass("slick-cloned") && !$element.hasClass("cbt-listed")) {
            $element.addClass("cbt-listed");
            var productCbtData = cbtUtil.parseJSON($(el).find(".producttile-add-to-cart").data("cbt"));
            //The GTM attribute products of productCbtData only contains one product even though it is plural
            //The GTM attribute products of dataLayer will contain multiple products
            if (productCbtData && productCbtData.products) {
                productCbtData.products[0].position = $element.data("slick-index") + 1;
                dataLayer.products.push(productCbtData.products[0]);
            }
        }
    });
    if (dataLayer.products.length) {
        cbtUtil.dataPush(dataLayer);
    }
}

function clearDatalayerFuturePushQueue () {
    if ($(".page[data-action='Product-Show']").length === 0) {
        deleteCookie("eeListClick_pdp_doPush");
    }
}

/**
 * Helper function to create the dataLayer and push it for PDP Zoom Interaction
 * @param {String} productName
 * @param {String} interactionType
 */
function createAndPushDataLayerZoomInteraction (productName, interactionType) {
    var dataLayer = {
        "event": "productFeature",
        "interactionType": interactionType,
        "productName": productName
    };
    cbtUtil.dataPush(dataLayer);
}

function cbtPDPZoomInteraction () {
    var productName = $(".pdp-arrow-border").data("product-name");
    $(document).on("click", ".pdp-arrow-border img", function() {
        createAndPushDataLayerZoomInteraction (productName, "Zoom picture");
    });
    $(document).on("click", ".modal .trigger-photo-swipe", function() {
        createAndPushDataLayerZoomInteraction (productName, "Switch zoomed picture");
    });
    $(document).on("click", ".pswp img.pdp-thumbnail", function() {
        createAndPushDataLayerZoomInteraction (productName, "Switch zoomed picture");
    });
}

/**
 * Get and push the age gate event
 */
function cbtAgeGateEvent() {
    var dataLayer = $(".age-gate").data("cbt");

    if (dataLayer) {
        cbtUtil.dataPush(dataLayer);
    }
}

/**
 * Attach click event on eRetailer link to send tracking data
 */
function cbtSelectedERetailer() {
    if ($(".eretailers-wrapper").length) {
        $("body").on("click", ".eretailers-button", function () {
            const $this = $(this);
            let dataLayer = cbtUtil.parseJSON($this.data("cbt"));

            if (dataLayer) {
                cbtUtil.dataPush(dataLayer);
            }
        });
    }
}

initCache();

document.addEventListener("DOMContentLoaded", function() {
    cbtSocialNetworks();
    setSuggestionsCookie();
    cbtProductTileClick();
    cbtCLPAddToCartData();
    clearDatalayerFuturePushQueue();
});

window.addEventListener("load", function () {
    cbtAgeGateEvent();
    footerLinksEvent();
    cbtProductListViewGrowth();
    ctbFormValidationError();
    cbtPDPZoomInteraction();
    cbtSelectedERetailer();
});
